// Container imports
const feedActions = require('../containers/feed/actions')

/** @typedef { import('redux').Middleware } ReduxMiddleware */

// Middlewares

/**
 * @returns {ReduxMiddleware}
 */
function searchFeedSideEffectsMiddleware() {
  return store => next => action => {
    next(action)
    if (action.type === feedActions.MORE_LOADED) {
      const state = store.getState()
      if (state.router.action === 'search.showQueryPosts') {
        store.dispatch(feedActions.dedupeSimilarArticles())
      }
    }
  }
}

module.exports = {
  searchFeedSideEffectsMiddleware
}
